import Mitt from "mitt"
import * as React from "react"

export enum Events {
    ORDER_PLACED = "ORDER_PLACED",
}

export interface EventContextInterface {
    events: Mitt.Emitter
}

interface Props {}

export const EventContext = React.createContext<EventContextInterface | null>(null)

class EventProvider extends React.PureComponent<Props> {
    events: Mitt.Emitter = new Mitt()

    render = () => (
        <EventContext.Provider
            value={{
                events: this.events,
            }}>
            {this.props.children}
        </EventContext.Provider>
    )
}

const EventConsumer = EventContext.Consumer

export { EventConsumer, EventProvider }
